import { PrimaryButton } from '@carvana/showroom-forms';
import { CommonModuleInner } from '@/sem/styles';
import { type SemInventoryModule } from '~/contracts/sem/SemLandingPageContent';
import GridSection from './GridSection';
import InventoryCarousel from './InventoryCarousel';
import SemTrackWrapper from '../SemTrackWrapper';

type OwnProps = Omit<SemInventoryModule, '__typename'>;

const MIN_TILES = 4;

function Inventory({ id, sections = [], buttonText, buttonUrl }: OwnProps) {
  const validSections = sections?.length
    ? sections.filter(
        section =>
          section?.inventory?.length && section?.inventory?.length >= MIN_TILES
      )
    : [];

  if (!id || !sections?.length || !validSections?.length) return null;

  const hasMultipleFilters = validSections.length > 1;

  const gridSection = validSections.length > 0 ? validSections[0] : sections[0];

  return (
    <SemTrackWrapper sectionName="Inventory">
      <CommonModuleInner>
        {hasMultipleFilters ? (
          <div className="w-full">
            {validSections?.map(section => {
              return section ? (
                <InventoryCarousel key={section?.title} {...section} />
              ) : null;
            })}
            {buttonUrl && (
              <a
                href={buttonUrl}
                data-analytics-id="Inventory - Shop All CTA"
                data-analytics-attributes={JSON.stringify({
                  title: buttonText,
                  linkUrl: buttonUrl
                })}
                className="no-underline"
              >
                <PrimaryButton className="mx-auto max-w-[327px]">
                  {buttonText}
                </PrimaryButton>
              </a>
            )}
          </div>
        ) : gridSection && gridSection?.id ? (
          <GridSection {...gridSection} />
        ) : null}
      </CommonModuleInner>
    </SemTrackWrapper>
  );
}

export default Inventory;
